import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/SupplierModels.cs ----------

export type SupplierAddressType = 'Comanda' | 'Livrare' | 'Facturare'

export interface SupplierAddress {
  id: string | null
  type: SupplierAddressType
  line: string
  city: string | null
  county: string | null
  postalCode: string | null
  country: string | null
}

export interface SupplierContact {
  id: string | null
  name: string
  jobTitle: string | null
  phone: string | null
  email: string | null
}

export interface SupplierListItem {
  id: string
  code: string
  name: string
  cui: string | null
  category: string | null
  leadTimeDaysStandard: number | null
  isActive: boolean
}

export interface SupplierDetail {
  id: string
  code: string
  name: string
  cui: string | null
  address: string | null
  city: string | null
  country: string | null
  paymentTermDays: number | null
  leadTimeDaysStandard: number | null
  category: string | null
  notes: string | null
  isActive: boolean
  addresses: SupplierAddress[]
  contacts: SupplierContact[]
}

export type SaveSupplierPayload = Omit<SupplierDetail, 'id' | 'isActive'>

export interface SupplierArticlePrice {
  id: string
  price: number
  currency: string
  unitOfMeasureId: string
  unitOfMeasureCode: string
  validFrom: string
  validTo: string | null
}

export interface SupplierArticle {
  id: string
  articleId: string
  articleCode: string
  articleDescription: string
  supplierArticleCode: string | null
  isDefault: boolean
  prices: SupplierArticlePrice[]
}

export interface SupplierCertification {
  id: string
  type: string
  issuedAt: string | null
  expiresAt: string
  notes: string | null
}

export const listSuppliers = (search?: string, articleId?: string) =>
  api.get<SupplierListItem[]>('/achizitii/furnizori', { params: { search: search || undefined, articleId: articleId || undefined } }).then((r) => r.data)

export const getSupplier = (id: string) => api.get<SupplierDetail>(`/achizitii/furnizori/${id}`).then((r) => r.data)

export const createSupplier = (payload: SaveSupplierPayload) =>
  api.post<{ id: string }>('/achizitii/furnizori', payload).then((r) => r.data)

export const updateSupplier = (id: string, payload: SaveSupplierPayload) =>
  api.put(`/achizitii/furnizori/${id}`, payload)

export const deactivateSupplier = (id: string) => api.post(`/achizitii/furnizori/${id}/deactivate`)
export const reactivateSupplier = (id: string) => api.post(`/achizitii/furnizori/${id}/reactivate`)

// ---------- articole furnizate ----------

export const listSupplierArticles = (supplierId: string) =>
  api.get<SupplierArticle[]>(`/achizitii/furnizori/${supplierId}/articole`).then((r) => r.data)

export const addSupplierArticle = (supplierId: string, payload: { articleId: string; supplierArticleCode?: string | null; isDefault: boolean }) =>
  api.post<{ id: string }>(`/achizitii/furnizori/${supplierId}/articole`, payload).then((r) => r.data)

export const updateSupplierArticle = (supplierArticleId: string, payload: { supplierArticleCode?: string | null; isDefault: boolean }) =>
  api.put(`/achizitii/furnizori/articole/${supplierArticleId}`, payload)

export const addSupplierArticlePrice = (
  supplierArticleId: string,
  payload: { price: number; currency: string; unitOfMeasureId: string; validFrom: string; validTo?: string | null },
) => api.post<{ id: string }>(`/achizitii/furnizori/articole/${supplierArticleId}/preturi`, payload).then((r) => r.data)

// ---------- certificări ----------

export const listSupplierCertifications = (supplierId: string) =>
  api.get<SupplierCertification[]>(`/achizitii/furnizori/${supplierId}/certificari`).then((r) => r.data)

export const addSupplierCertification = (supplierId: string, payload: { type: string; issuedAt?: string | null; expiresAt: string; notes?: string | null }) =>
  api.post<{ id: string }>(`/achizitii/furnizori/${supplierId}/certificari`, payload).then((r) => r.data)

export const updateSupplierCertification = (certificationId: string, payload: { type: string; issuedAt?: string | null; expiresAt: string; notes?: string | null }) =>
  api.put(`/achizitii/furnizori/certificari/${certificationId}`, payload)
